export default __webpack_public_path__ + "static/my-a62cedcf92e94d9103f7fad68af2c2c7.svg";